import { create } from '@bufbuild/protobuf'

import { CustomerSchema } from '@jotta/grpc-connect-openapi/customer'
import {
  AccountType,
  Customer_TFAType,
  PhotoState,
  QuotaState,
  SubscriptionType,
} from '@jotta/grpc-connect-openapi/customer'
import { Language } from '@jotta/grpc-connect-openapi/language'
import { WopiConsent } from '@jotta/grpc-connect-openapi/wopi'

export const emptyCustomer = create(CustomerSchema, {
  username: '',
  email: '',
  fullName: '',
  phoneNumber: '',
  phoneNumberVerified: false,
  countryCode: '',
  languageCode: '',
  language: Language.UNKNOWN_LANGUAGE,
  usageBytes: 0n,
  quotaBytes: 0n,
  photoState: PhotoState.UNKNOWN_PHOTO_STATE,
  accountType: AccountType.UNKNOWN_ACCOUNT_TYPE,
  subscriptionType: SubscriptionType.UNKNOWN_SUBSCRIPTION_TYPE,
  brandingInfo: {
    brandCode: '',
    brandName: '',
    customerGroupCode: '',
    customerGroupName: '',
  },
  wopiConsent: WopiConsent.UNKNOWN,
  tfaType: Customer_TFAType.NONE,
  messages: [],
  promoteUpgrade: false,
  canTerminateAccount: false,
  quota: QuotaState.VALID,
})
